import { useIsWithinTailWindBreakpoint } from 'noddi-ui-web';
import { useBookingTimeWindow } from 'noddi-web';
import { BookingFlowBottomBar, BookingFlowNextButtonProps } from '../Common/BookingFlowBottomBar';
import { NavioContactChatWidget } from '../Common/NavioContactChatWidget';
import { BookingValidationModal, BookingValidationVariant } from './BookingValidationModal';
import { SelectedCars } from './SelectedCars';
import { SelectedTimeWindow } from './SelectedTimeWindow';
import { ShoppingCart } from './ShoppingCart';

type FixedBottomBarProps = BookingFlowNextButtonProps & {
  hideBackButton?: boolean;
  hideShoppingCart?: boolean;
  showSelectedCars?: boolean;
  showSelectedTimeWindow?: boolean;
  validationVariant: BookingValidationVariant;
};

export const FixedBookingScreenBottomBar = ({
  hideBackButton,
  hideShoppingCart,
  showSelectedCars,
  showSelectedTimeWindow,
  validationVariant,
  ...nextButtonProps
}: FixedBottomBarProps) => {
  const selectedTimeWindow = useBookingTimeWindow();
  const isXs = useIsWithinTailWindBreakpoint('xs');

  const showShoppingCart = !hideShoppingCart;
  const hasCompactControls = (showShoppingCart || showSelectedCars || showSelectedTimeWindow) && isXs;

  return (
    <BookingFlowBottomBar
      {...nextButtonProps}
      hideBackButton={hideBackButton}
      leading={<NavioContactChatWidget size={hasCompactControls ? 'small' : 'medium'} />}
      controls={
        <>
          {showShoppingCart && <ShoppingCart />}
          {showSelectedCars && <SelectedCars />}
          {showSelectedTimeWindow && <SelectedTimeWindow selectedTimeWindow={selectedTimeWindow} layout='chip' />}
        </>
      }
      renderValidationModal={({ open, onClose }) => (
        <BookingValidationModal open={open} onClose={onClose} variant={validationVariant} />
      )}
    />
  );
};
